import { Box, ButtonBase, Typography, alpha } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import { openCommandPalette } from '@/components/CommandPalette/commandPaletteEvents';

const isMac =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad/.test(navigator.platform);

/** Header entry to the Ctrl+K palette, showing the shortcut. */
const HeaderSearchButton = () => {
  const { t } = useTranslation();
  return (
    <ButtonBase
      onClick={openCommandPalette}
      aria-label={t('commandPalette.open')}
      sx={(theme) => ({
        display: { xs: 'none', md: 'inline-flex' },
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 0.75,
        minWidth: 220,
        borderRadius: 1,
        color: 'text.secondary',
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: alpha(theme.palette.background.paper, 0.6),
        '&:hover': { borderColor: theme.palette.primary.main }
      })}
    >
      <SearchIcon fontSize="small" />
      <Typography variant="body2" sx={{ flex: 1, textAlign: 'left' }}>
        {t('commandPalette.button')}
      </Typography>
      <Box
        component="kbd"
        sx={(theme) => ({
          px: 0.75,
          borderRadius: 0.5,
          fontSize: 12,
          fontFamily: 'inherit',
          border: `1px solid ${theme.palette.divider}`
        })}
      >
        {isMac ? '⌘K' : 'Ctrl K'}
      </Box>
    </ButtonBase>
  );
};

export default HeaderSearchButton;
